module.exports = __webpack_public_path__ + "static/media/briefcase.2d99d1ce.svg";